<template>
  <div class="iv-main-nav iv-main-width" v-if="currentView != '制度索引'">
    <ul>
      <router-link tag="li"
                   class="iv-fs-16 iv-text-center iv-pointer"
                   :class="(item.label == currentView) ? 'activeLi' : ''"
                   v-for="(item, index) in navList"
                   :key="index"
                   :to="getUrlPath(item)">
        {{ item.label }}
      </router-link>
    </ul>
  </div>
</template>
<script>
import info from './info'

export default {
  components: {},
  data() {
    return {
      currentView: '',
      navList: []
    }
  },
  watch: {
    '$route'() {
      this.getNavList()
    }
  },
  created() {
    this.navList = info.call(this)
    this.getNavList()
  },
  methods: {
    getNavList() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getColumn2List',
        method: 'get',
        data: {
          siteId: '95',//党群新闻站点id，
          id: '0'
        }
      }).then(({data}) => {
        if (data.code === 200) {
          this.navList = [];
          sessionStorage.setItem('userCode', data.userCode)
          // 修复data.data不存在的情况下的报错， this.navList会渲染info.js内的默认值
          const serverData = data.data ? data.data.filter((item) => !['zdsy','whdsj'].includes(item.columnCode)).map(item => {
            return {
              label: item.name,
              name: item.columnCode,
              categoryId: item.id,
              categoryType: item.type
            }
          }) : []
          this.navList.unshift({label: '首页', name: 'homePage'}, ...serverData)
        }
        this.setCurrActive()
        this.getHomeAbout()
      })
    },
    setCurrActive() {
      // let arr = this.$route.path.split('/')
      // arr.forEach((item, index) => {
      //   if (item == '') {
      //     arr.splice(index, 1)
      //   }
      // })
      // this.currentView = arr[0]
      this.currentView = this.$route.query.categoryName ? this.$route.query.categoryName : ''
    },
    getUrlPath(item) {
      if (!item.categoryId) return 'homePage'
      return item.name + '?categoryType=' + item.categoryType + '&categoryCode=' + item.name + '&categoryId=' + item.categoryId + '&categoryName=' + item.label + ''
    },
    getHomeAbout() {
      this.$ajax({
        url: 'api-qixuan/cms/front/getColumn2List',
        method: 'get',
        data: {
          siteId: '95',//党群新闻站点id，
          id: '0'
        }
      }).then(({data}) => {
        let navData = {}
        data.data.map(item => {
          navData[item.columnCode] = {
            label: item.name,
            name: item.columnCode,
            categoryId: item.id,
            categoryType: item.type
          }
        })
        this.$emit('nav-data', navData)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/new-blue/variable.scss';
// .router-link-active{
//   border-bottom: 3px solid #fff ;
// }

.iv-main-nav {
  ul {
    width: 100%;
    height: 56px;
    background-color: $iv-main-color;
    color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;

    li {
      height: 100%;
      line-height: 56px !important;

      &.activeLi {
        border-bottom: 3px solid #fff;
      }
    }
  }
}
</style>
